<template>
    <div id="fs5-get-paid-index">
        <div class="header" v-html="view[0]['translations']['earnings']"></div>
        <div class="content">
            <fs5-view-rank-details :view="view[0]"></fs5-view-rank-details>
            <br>
            <fs5-get-paid-collapse
                :view="{
                    title: view[0]['translations']['fs5_get_paid_tutorials'],
                    nameCollapse: 'statusCollapseEarns'+view[0]['user']['id'],
                    content: {
                        translation:{
                            header: view[0].title_video,
                            coming_soon: view[0].url_video_rank
                        },
                        urls: view[0].url_video_rank
                    }
                }">
                <div :slot="'content'" slot-scope="props">
                    <fs5-get-paid-tutorial :view="props.content"></fs5-get-paid-tutorial>
                </div>
            </fs5-get-paid-collapse>
            <br>
<!--            <div v-if="view.lang != 'br'" class="disable-withdraw">Due to the US Federal Holiday, commission withdrawal requests will close at 2pm ET, July 3rd, 2024.</div>-->
<!--            <br v-if="view.lang != 'br'">-->
            <fs5-request-payments :view="view[0]"/>
            <br>
            <fs5-earnings-notice :view="view[0]" />
            <br>
            <fs5-cards-status-payments :view="cards"></fs5-cards-status-payments>
            <br>
            <fs5-table-clients :view="view[0]"></fs5-table-clients>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'fs5-get-paid-index',
        props: ['view'],
        data() {
            let showUsd = true;
            let showBrl = true;
            let showEur = true;
            let showCzk = this.view[0].card['A_RECEBER']['CZK'] > 0 || this.view[0].card['NAO']['CZK'] > 0 || this.view[0].card['SOLICITADO']['CZK'] > 0 || this.view[0].card['SIM']['CZK'] > 0 ? true : false;
            let showThb = this.view[0].card['A_RECEBER']['THB'] > 0 || this.view[0].card['NAO']['THB'] > 0 || this.view[0].card['SOLICITADO']['THB'] > 0 || this.view[0].card['SIM']['THB'] > 0 ? true : false;
            let showInr = this.view[0].card['A_RECEBER']['INR'] > 0 || this.view[0].card['NAO']['INR'] > 0 || this.view[0].card['SOLICITADO']['INR'] > 0 || this.view[0].card['SIM']['INR'] > 0 ? true : false;
            return {
                cards: [
                    {
                        title: this.view[0].translations['fs5_on_hold'],
                        items: [
                            {type: 'USD', show: showUsd, symbol: '$',  value: this.view[0].card['A_RECEBER']['USD']},
                            {type: 'EUR', show: showEur, symbol: '€',  value: this.view[0].card['A_RECEBER']['EUR']},
                            {type: 'BRL', show: showBrl, symbol: 'R$', value: this.view[0].card['A_RECEBER']['BRL']},
                            {type: 'CZK', show: showCzk, symbol: 'Kč', value: this.view[0].card['A_RECEBER']['CZK']},
                            {type: 'THB', show: showThb, symbol: '฿',  value: this.view[0].card['A_RECEBER']['THB']},
                            {type: 'INR', show: showInr, symbol: '₹',  value: this.view[0].card['A_RECEBER']['INR']}
                        ],
                        style: '#FFDF34',
                        icon: 'clock.svg'
                    },
                    {
                        title: this.view[0].translations['office2_ganhos_disponivel'],
                        items: [
                            {type: 'USD', show: showUsd, symbol: '$',  value: this.view[0].card['NAO']['USD']},
                            {type: 'EUR', show: showEur, symbol: '€',  value: this.view[0].card['NAO']['EUR']},
                            {type: 'BRL', show: showBrl, symbol: 'R$', value: this.view[0].card['NAO']['BRL']},
                            {type: 'CZK', show: showCzk, symbol: 'Kč', value: this.view[0].card['NAO']['CZK']},
                            {type: 'THB', show: showThb, symbol: '฿',  value: this.view[0].card['NAO']['THB']},
                            {type: 'INR', show: showInr, symbol: '₹',  value: this.view[0].card['NAO']['INR']}
                        ],
                        style: '#F24988',
                        icon: 'pencil.svg'},
                    {
                        title: this.view[0].translations['office2_ganhos_solicitado'],
                        items: [
                            {type: 'USD', show: showUsd, symbol: '$',  value: this.view[0].card['SOLICITADO']['USD']},
                            {type: 'EUR', show: showEur, symbol: '€',  value: this.view[0].card['SOLICITADO']['EUR']},
                            {type: 'BRL', show: showBrl, symbol: 'R$', value: this.view[0].card['SOLICITADO']['BRL']},
                            {type: 'CZK', show: showCzk, symbol: 'Kč', value: this.view[0].card['SOLICITADO']['CZK']},
                            {type: 'THB', show: showThb, symbol: '฿',  value: this.view[0].card['SOLICITADO']['THB']},
                            {type: 'INR', show: showInr, symbol: '₹',  value: this.view[0].card['SOLICITADO']['INR']}
                        ],
                        style: '#9851C2',
                        icon: 'money.svg'},
                    {
                        title: this.view[0].translations['office2_ganhos_pago'],
                        items: [
                            {type: 'USD', show: showUsd, symbol: '$',  value: this.view[0].card['SIM']['USD']},
                            {type: 'EUR', show: showEur, symbol: '€',  value: this.view[0].card['SIM']['EUR']},
                            {type: 'BRL', show: showBrl, symbol: 'R$', value: this.view[0].card['SIM']['BRL']},
                            {type: 'CZK', show: showCzk, symbol: 'Kč', value: this.view[0].card['SIM']['CZK']},
                            {type: 'THB', show: showThb, symbol: '฿',  value: this.view[0].card['SIM']['THB']},
                            {type: 'INR', show: showInr, symbol: '₹',  value: this.view[0].card['SIM']['INR']}
                        ],
                        style: '#48CFAD',
                        icon: 'like.svg'},
                ]
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../scss/extras/_variables'; // see fonts and colors with prefix $fs5
    #fs5-get-paid-index {
        font-family: $fs5-font2;
    }
    .header{
        color: $fs5-color11;
        line-height: 1.2;
        font-weight: 900;
        font-size: 1.5em;
        margin-bottom: 0.7em;
        text-transform: uppercase;
    }
    .disable-withdraw {
      font: inherit;
      font-size: 1em;
      line-height: 1.2;
      color: #FFF;
      text-align: center;
      background: #FF4848;
      border-radius: 4px;
      padding: .5em;
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/get_paid/user/index.vue